module.exports = __webpack_public_path__ + "img/scene2.5379ef19.png";